export default __webpack_public_path__ + "static/media/Mark-3-HUD-Omega Widget.4bfe4bed.jpg";